// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-complete__img[data-v-0636ec36]{margin:30px auto}.import-complete__subheading[data-v-0636ec36]{font-weight:400}", ""]);
// Exports
module.exports = exports;
